// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Pervasives from "@rescript/runtime/lib/es6/Pervasives.js";
import * as Stdlib_Float from "@rescript/runtime/lib/es6/Stdlib_Float.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Stdlib_Result from "@rescript/runtime/lib/es6/Stdlib_Result.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as Primitive_exceptions from "@rescript/runtime/lib/es6/Primitive_exceptions.js";

function cellFromIndex(index, value) {
  switch (index) {
    case 0 :
      return {
        TAG: "Reference",
        _0: value
      };
    case 1 :
      return {
        TAG: "Quantity",
        _0: value
      };
    case 2 :
      return {
        TAG: "Price",
        _0: value
      };
    default:
      return "Unknown";
  }
}

function floatFromString(value) {
  let value$1 = Stdlib_Float.fromString(value.replace(",", "."));
  if (value$1 !== undefined) {
    return {
      TAG: "Ok",
      _0: value$1
    };
  } else {
    return {
      TAG: "Error",
      _0: undefined
    };
  }
}

let referenceRegex = /^[\w-]+$/;

let quantityAndPriceRegex = /^(?:(?:\d+(?:,\d{1,3})?(?:\.\d{1,3})?)|(?:.\d+))$/;

function validateCellFromLabel(cell) {
  if (typeof cell !== "object") {
    return {
      TAG: "Error",
      _0: "invalid column"
    };
  }
  switch (cell.TAG) {
    case "Reference" :
      let test = referenceRegex.test(cell._0);
      if (test) {
        return {
          TAG: "Ok",
          _0: undefined
        };
      } else {
        return {
          TAG: "Error",
          _0: "invalid reference (SKU)"
        };
      }
    case "Quantity" :
      let value = cell._0;
      let test$1 = quantityAndPriceRegex.test(value);
      let test$2 = test$1 && Stdlib_Result.mapOr(floatFromString(value), false, quantity => quantity > 0);
      if (test$2) {
        return {
          TAG: "Ok",
          _0: undefined
        };
      } else {
        return {
          TAG: "Error",
          _0: "invalid quantity"
        };
      }
    case "Price" :
      let valueOptional = cell._0;
      let test$3 = valueOptional !== undefined ? quantityAndPriceRegex.test(valueOptional) : true;
      if (test$3) {
        return {
          TAG: "Ok",
          _0: undefined
        };
      } else {
        return {
          TAG: "Error",
          _0: "invalid purchasing price"
        };
      }
  }
}

function entryValueFromOption(entry) {
  if (entry !== undefined) {
    return Primitive_option.valFromOption(entry);
  } else {
    return Pervasives.failwith("Unexpected error when parsing an Order CSV entry.");
  }
}

let StringToQuantityFailure = /* @__PURE__ */Primitive_exceptions.create("OrderCsvImporting__Config.StringToQuantityFailure");

let StringToUnitPriceFailure = /* @__PURE__ */Primitive_exceptions.create("OrderCsvImporting__Config.StringToUnitPriceFailure");

function rowFromEntryExn(entry) {
  let reference = entryValueFromOption(entry[0]);
  let quantity = entryValueFromOption(entry[1]);
  let price = entry[2];
  let value = floatFromString(quantity);
  let tmp;
  if (value.TAG === "Ok") {
    tmp = value._0;
  } else {
    throw {
      RE_EXN_ID: StringToQuantityFailure,
      Error: new Error()
    };
  }
  return {
    sku: reference,
    quantity: tmp,
    unitPrice: Stdlib_Option.map(price, price => {
      let value = floatFromString(price);
      if (value.TAG === "Ok") {
        return value._0;
      }
      throw {
        RE_EXN_ID: StringToUnitPriceFailure,
        Error: new Error()
      };
    })
  };
}

let ParserConfig = {
  cellFromEntryIndex: cellFromIndex,
  validateCellFromLabel: validateCellFromLabel,
  rowFromEntry: rowFromEntryExn
};

export {
  cellFromIndex,
  floatFromString,
  referenceRegex,
  quantityAndPriceRegex,
  validateCellFromLabel,
  entryValueFromOption,
  StringToQuantityFailure,
  StringToUnitPriceFailure,
  rowFromEntryExn,
  ParserConfig,
}
/* No side effect */
